import NameInfo from "components/NameInfo";

export default NameInfo;
